export default __webpack_public_path__ + "static/media/rsa.839d23b7.svg";